import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getInventoryAttributes,
  postInventoryAttribute,
  patchInventoryAttribute,
  GetInventoryAttributesParamsType,
  PostInventoryAttributePayloadType,
  PatchInventoryAttributePayloadType,
} from 'features/SupplyOrder/services/outboundSKUConfig'
import { getKongLocationAll } from 'features/Location/services/location'
import { getProductList } from 'features/Product/services/product'
import { getProductDetailApi } from 'features/Product/services/productMasterDetail'
import { callErrorMsg } from 'helpers/errorMsg'
import { getCleanQueryObj } from 'utils/queryParamsURL'
import { toastSuccess } from 'utils/toast'

export const SLICE_NAME_OUTBOUND_SKU_CONFIG = 'OUTBOUND_SKU_CONFIG'

export const fetchInventoryAttributeList = createAsyncThunk(
  `${SLICE_NAME_OUTBOUND_SKU_CONFIG}/fetchInventoryAttributeList`,
  async (queryParams: Partial<GetInventoryAttributesParamsType>, { rejectWithValue }) => {
    try {
      const paramsToSubmit = getCleanQueryObj(queryParams)
      const { data } = await getInventoryAttributes(paramsToSubmit)

      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const createInventoryAttribute = createAsyncThunk(
  `${SLICE_NAME_OUTBOUND_SKU_CONFIG}/createInventoryAttribute`,
  async (payload: PostInventoryAttributePayloadType, { rejectWithValue }) => {
    try {
      const { data } = await postInventoryAttribute(payload)

      toastSuccess('Berhasil menambahkan produk')

      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchFilterLocations = createAsyncThunk(
  `${SLICE_NAME_OUTBOUND_SKU_CONFIG}/fetchFilterLocations`,
  async (name: string | undefined, { rejectWithValue }) => {
    try {
      const { data } = await getKongLocationAll({
        params: {
          name: name || '',
          active: true,
          page: 0,
          limit: 20,
        },
      })

      return data.data.location
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchFilterProducts = createAsyncThunk(
  `${SLICE_NAME_OUTBOUND_SKU_CONFIG}/fetchFilterProducts`,
  async (name: string | undefined, { rejectWithValue }) => {
    try {
      /* eslint-disable @typescript-eslint/naming-convention */
      const { data } = await getProductList({
        'pagination.page_size': 20,
        'pagination.page_index': 1,
        ...(name && { 'filter.name': name }),
      })
      /* eslint-enable @typescript-eslint/naming-convention */

      return data.data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchSelectedProductDetails = createAsyncThunk(
  `${SLICE_NAME_OUTBOUND_SKU_CONFIG}/fetchSelectedProductDetails`,
  async (productIds: number[], { rejectWithValue }) => {
    try {
      const responses = await Promise.all(productIds.map((id) => getProductDetailApi(id)))

      return responses.map(({ data }) => data.data)
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const updateInventoryAttribute = createAsyncThunk(
  `${SLICE_NAME_OUTBOUND_SKU_CONFIG}/updateInventoryAttribute`,
  async (payload: PatchInventoryAttributePayloadType, { rejectWithValue }) => {
    try {
      const { data } = await patchInventoryAttribute(
        payload.product_id,
        payload.location_id,
        payload,
      )

      toastSuccess(data.message || 'Berhasil melakukan update inventory attribute')

      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
